"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var features_1 = require("../features");
var components_1 = require("../components");
var utils_1 = require("../utils");
var CheckboxWrap = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"], ["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n"])));
exports.gridCheckboxWrapId = 'grid-checkbox-wrap';
var checkboxCellRenderer = function (_a) {
    var rowData = _a.rowData, rowIndex = _a.rowIndex, rowDisabled = _a.disabled, inactive = _a.inactive, isRowDisabled = _a.isRowDisabled;
    var _b = features_1.useGridContext(), _c = _b.state, data = _c.data, selection = _c.selection, gridDisabled = _c.disabled, onSelectionChange = _b.onSelectionChange;
    var checked = !!(selection === null || selection === void 0 ? void 0 : selection.selected.find(function (row) { return rowData[selection.field] === row[selection.field]; }));
    var disabled = gridDisabled || rowDisabled;
    return (react_1.default.createElement(CheckboxWrap, { "data-selector-id": exports.gridCheckboxWrapId },
        react_1.default.createElement(components_1.GridCheckbox, { checked: checked, disabled: disabled, onClick: function (checked, e) {
                if (disabled) {
                    return;
                }
                var keyboard = {
                    meta: e.nativeEvent.metaKey,
                    ctrl: e.nativeEvent.ctrlKey,
                    shift: e.nativeEvent.shiftKey
                };
                if (onSelectionChange) {
                    onSelectionChange({
                        selected: utils_1.updateSelected({
                            selection: selection,
                            rowData: rowData,
                            isRowDisabled: isRowDisabled,
                            rowClick: false,
                            keyboard: keyboard,
                            data: data
                        }),
                        current: { rowIndex: rowIndex, rowData: rowData }
                    });
                }
            } })));
};
exports.default = checkboxCellRenderer;
var templateObject_1;
//# sourceMappingURL=checkboxCellRenderer.js.map